import React from 'react';
import styled from 'styled-components';

const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  background-color: white;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 0.6rem 0.75rem;
  width: 100%;
  transition: all 0.2s ease;
  box-sizing: border-box;
  flex: 1;
  min-width: 0;
  
  &:focus-within {
    border-color: #e74c3c;
    box-shadow: 0 0 0 3px rgba(231, 76, 60, 0.1);
  }
`;

const Label = styled.label`
  font-size: 0.7rem;
  font-weight: 700;
  color: #718096;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 0.1rem;
`;

const InputWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
`;

const Input = styled.input`
  flex: 1;
  border: none;
  background: transparent;
  font-size: 1.2rem;
  font-weight: 700;
  color: #2d3748;
  padding: 0;
  font-family: inherit;
  
  &:focus {
    outline: none;
  }

  &::placeholder {
    color: #cbd5e0;
  }
`;

const CurrencySymbol = styled.span`
  color: #718096;
  font-weight: 700;
  font-size: 1rem;
`;

interface CurrencyInputProps {
  label?: string;
  value: number;
  onChange: (value: number) => void;
  onFocus?: (e: React.FocusEvent<HTMLInputElement>) => void;
  autoFocus?: boolean;
  disabled?: boolean;
}

const CurrencyInput: React.FC<CurrencyInputProps> = ({ 
  label, 
  value, 
  onChange, 
  onFocus,
  autoFocus,
  disabled
}) => {
  const formatValue = (val: number) => {
    return new Intl.NumberFormat('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(val);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (disabled) return;
    const rawValue = e.target.value.replace(/\D/g, '');
    const numberValue = parseInt(rawValue || '0', 10) / 100;
    onChange(numberValue);
  };

  return (
    <FormGroup style={disabled ? { backgroundColor: '#f7fafc', cursor: 'not-allowed', opacity: 0.7 } : {}}>
      {label && <Label>{label}</Label>}
      <InputWrapper>
        <CurrencySymbol>R$</CurrencySymbol>
        <Input
          type="text"
          inputMode="numeric"
          value={formatValue(value)}
          onChange={handleChange}
          onFocus={onFocus}
          autoFocus={autoFocus}
          disabled={disabled}
        />
      </InputWrapper>
    </FormGroup>
  );
};

export default CurrencyInput;
